import StatsContainer from './stats-container';

export default StatsContainer;
